import { Field } from 'formik'
import React, { useEffect, useState } from 'react'

const EditTitleStatus = ({values, setShowEtitleBox, setFieldValue, selectedOptions, updateNote}) => {
    
    const [isLenderDisabled, setIsLenderDisabled] = useState(true);
    useEffect(() => {
        const status = values.titlestatus;
        const disabled = !(status === 'Financed' || status === 'Lease');
        setIsLenderDisabled(disabled);
        if(setShowEtitleBox) setShowEtitleBox(values.titlestatus);
        if(disabled) setFieldValue("lender","");

        updateNote();
    }, [values.titlestatus]);
  return (
    <>
        <div className='col-md-6 mb-4'>
            <div className='adr-label mb-1'>Title Status</div>
            <Field name="titlestatus" as="select" className='form-control'>
                <option value="">Select</option>
                <option value="Paper Title">Paper Title</option>
                <option value="E-Title">E-Title</option>
                <option value="Financed">Financed</option>
                <option value="Lease">Lease</option>
            </Field>
        </div>
        <div className='col-md-6'>
            <div className='mb-4'>
                <div className='adr-label mb-1'>Lender</div>
                <Field name="lender" type="text" className='form-control' disabled={isLenderDisabled} />
            </div>
        </div>
    </>
  )
}

export default EditTitleStatus